<script>
    import { attach } from "shared/eventBus";
    import { get, getJson, getIbeHost } from "shared/Utilities/fetchUtilities"
    import slider from "shared/Components/slider.vue";
    import moment from "moment";
    import cancellations from "shared/Components/cancellations.vue";

    let showCancellationSliderToggleURL = "/F9/showCancellationSlider";
    let dataRelativePath = "/F9/GetCancellations",
        dateFormat = "YYYY-MM-DD";

    export default {
        props: {
            openEvent: {
                type: String,
                default: "showCancellationSlider"
            },
            endDate: {
                type: Date | String,
                default: () => moment().add(99, 'days').toDate()
            },
            startDate: {
                type: Date | String,
                default: () => moment().subtract(5, 'days').toDate()
            },
            value: Boolean
        },
        data() {
            return {
                sliderVisible: false,
                cancellationData: [],
                host: getIbeHost(),
                dataLoaded: false
            }
        },
        created() {
            getJson(this.showCancellationSliderToggleUrl, false, true).then(showSlider => {
                attach(this.openEvent, () => this.sliderVisible = showSlider);
                this.$parent.$emit('cancellationSliderCreated');
            }); 
        },
        watch: {
            sliderVisible(val) {
                if(val && !this.dataLoaded) {
                    this.$nextTick(() => getJson(this.requestUrl).then(json => {
                        this.cancellationData = json;
                        this.dataLoaded = true;
                    }));                    
                }
                this.$emit('input', val);
            },
            value(val) {
                this.sliderVisible = val;
            }
        },
        computed: {
            requestUrl() {
                return `${this.host}${dataRelativePath}?startDate=${this.startDateString}&endDate=${this.endDateString}`;
            },
            showCancellationSliderToggleUrl(){
                return `${this.host}${showCancellationSliderToggleURL}`;
            },
            startDateString() {
                if(typeof(this.startDate) === "string") {
                    return this.startDate;
                }

                return moment(this.startDate).format(dateFormat)
            },
            endDateString() {
                if(typeof(this.endDate) === "string") {
                    return this.endDate;
                }

                return moment(this.endDate).format(dateFormat)
            }
        },
        components: {
            slider,
            cancellations
        }
    }
</script>

<template>
    <slider ref="slider" title="Cancellations" v-model="sliderVisible">
        <cancellations v-show="dataLoaded" :items="cancellationData"></cancellations>
    </slider>
</template>
